/** Colores base de la app (Click Away). Deben coincidir con `plugins/vuetify.js`. */
export const DEFAULT_THEME_COLORS = {
  primary: '#7800C6',
  secondary: '#FF7F00'
}

export const LAST_CLIENT_STORAGE_KEY = 'clickaway_last_client'
